import TheCarousel from "@/components/TheCarousel";
import VueProgressiveImage from 'vue-progressive-image'
import Vue from "vue"
let Carousel = Vue.extend(TheCarousel);
Vue.use(VueProgressiveImage);

let processors = [
	{ /* Titles */
		prerender(x) {
			return x;
		},
		postrender(x) {
			return x.replace(/<h[1-6]>.*<\/h[1-6]>/g, full =>
				`<div class="md-title-wrapper">${full}</div>`);
		},
		rendered() {}
	},
	{ /* Number Box */
		prerender(x) {
			return x;
		},
		postrender(x) {
			return x.replace(/<numbers values="(.*)" labels="(.*)" style="(.*)"><\/numbers>/g,
					(full, values, labels, style) => {
				let innerHTML = "";
				values = values.split(",");
				labels = labels.split(",");
				for (let i in values) {
					innerHTML += `<div class="md-number-box">
						<div class="md-number-box-label">${labels[i]}</div>
						<div class="md-number-box-value">${values[i]}</div>
					</div>`;
				}
				return `<div class="md-number-box-container" style="${style}">${innerHTML}</div>`;
			});
		},
		rendered() {}
	},
	{ /* Carousel */
		prerender(x) {
			return x;
		},
		postrender(x) {
			return x.replace(/<carousel(.*)><\/carousel>/g, (full, matched) =>
				`<div class="md-carousel" ${matched}></div>`);
		},
		rendered(selector) {
			setImmediate(() => {
				let md = document.querySelector(selector);
				md.querySelectorAll(".md-carousel")
					.forEach((c) => {
						let instance = new Carousel({
							propsData: {
								images: c.getAttribute("images").split(",")
							}
						});
						instance.$mount();
						c.appendChild(instance.$el);
					});
			});
		}
	}
];

export default {
	prerender(x) {
		return processors.reduce((prev, curr) => curr.prerender(prev), x);
	},
	postrender(x) {
		return processors.reduce((prev, curr) => curr.postrender(prev), x);
	},
	rendered(el) {
		processors.forEach((p) => p.rendered(el));
	}
}